import React, { useState, useEffect } from "react";
import BusinessCard from "./tabs/business-card";
import Carousel from "./tabs/carousel";
import AboutUs from "./tabs/about-us";
import ProductComponent from "./tabs/product";
import ServiceComponent from "./tabs/service";
import ContractComponent from "./tabs/contract";
import ContactUsComponent from "./tabs/contact-us";
import ApprenticesComponent from "./tabs/apprenticeship";
import VacancyComponent from "./tabs/vacancy";
import Courses from "./tabs/courses";
import WhyWorkForUs from "./tabs/WhyWorkforus";
import TeamsAndRoles from "./tabs/TeamsRoles";
// import WorkExperienceCopy from "./tabs/work-experience copy";
import NewsTab from "./tabs/NewsTab";
import PressTab from "./tabs/PressTab";
import { TAB_KEYS } from "../../../config";
import WorkExperienceNew from "./tabs/workExperienceNew/WorkExperience";

// preserve order in which tabs are rendered
const tabsOrder = [
  {
    masterDataId: "35499f49-0937-11f0-b61c-6045bd0fa337",
    oldName: "Business Card",
    oldTabKey: "businessCard",
    tabKey: TAB_KEYS.businessCard,
  },
  {
    masterDataId: "3549a077-0937-11f0-b61c-6045bd0fa337",
    oldName: "Home carousel",
    oldTabKey: "corousel",
    tabKey: TAB_KEYS.corousel,
  },
  {
    masterDataId: "3549a199-0937-11f0-b61c-6045bd0fa337",
    oldName: "About Us",
    oldTabKey: "about-us",
    tabKey: TAB_KEYS.aboutUs,
  },
  {
    masterDataId: "35499238-0937-11f0-b61c-6045bd0fa337",
    oldName: "Products",
    oldTabKey: "product",
    tabKey: TAB_KEYS.product,
  },
  {
    masterDataId: "35499789-0937-11f0-b61c-6045bd0fa337",
    oldName: "Services",
    oldTabKey: "service",
    tabKey: TAB_KEYS.service,
  },
  {
    masterDataId: "35499d06-0937-11f0-b61c-6045bd0fa337",
    oldName: "Contracts",
    oldTabKey: "contract",
    tabKey: TAB_KEYS.contract,
  },
  {
    masterDataId: "3549a0ff-0937-11f0-b61c-6045bd0fa337",
    oldName: "Contact Us",
    oldTabKey: "contact-us",
    tabKey: TAB_KEYS.contactUs,
  },
  {
    masterDataId: "35499a04-0937-11f0-b61c-6045bd0fa337",
    oldName: "Apprenticeships",
    oldTabKey: "PART_TIME",
    tabKey: TAB_KEYS.apprenticeship,
  },
  {
    masterDataId: "35499943-0937-11f0-b61c-6045bd0fa337",
    oldName: "Vacancies",
    oldTabKey: "FULL_TIME",
    tabKey: TAB_KEYS.vacancy,
  },
  {
    masterDataId: "35499b63-0937-11f0-b61c-6045bd0fa337",
    oldName: "Courses",
    oldTabKey: "courses",
    tabKey: TAB_KEYS.courses,
  },
  {
    masterDataId: "35499c7c-0937-11f0-b61c-6045bd0fa337",
    oldName: "Why work for us",
    oldTabKey: "why-work",
    tabKey: TAB_KEYS.whyWorkForUs,
  },
  {
    masterDataId: "35499ab7-0937-11f0-b61c-6045bd0fa337",
    oldName: "Our teams and roles",
    oldTabKey: "teams-and-roles",
    tabKey: TAB_KEYS.teamsAndRoles,
  },
  {
    masterDataId: "35499bf8-0937-11f0-b61c-6045bd0fa337",
    oldName: "Experiences of work",
    oldTabKey: "work-experience",
    tabKey: TAB_KEYS.workExperience,
  },
  {
    masterDataId: "35499d91-0937-11f0-b61c-6045bd0fa337",
    oldName: "Blog",
    oldTabKey: "news_tab",
    tabKey: TAB_KEYS.news,
  },
  {
    masterDataId: "35499e19-0937-11f0-b61c-6045bd0fa337",
    oldName: "In The Press",
    oldTabKey: "press",
    tabKey: TAB_KEYS.press,
  },
];

const masterDataToComponentMapping = (masterDataId, props) => {
  switch (masterDataId) {
    case "35499ab7-0937-11f0-b61c-6045bd0fa337":
      return <TeamsAndRoles {...props} />;
    case "35499f49-0937-11f0-b61c-6045bd0fa337":
      return <BusinessCard {...props} />;
    case "35499e19-0937-11f0-b61c-6045bd0fa337":
      return <PressTab {...props} />;
    case "3549a077-0937-11f0-b61c-6045bd0fa337":
      return <Carousel {...props} />;
    case "35499bf8-0937-11f0-b61c-6045bd0fa337":
      return <WorkExperienceNew {...props} />;
    case "35499d91-0937-11f0-b61c-6045bd0fa337":
      return <NewsTab {...props} />;
    case "35499b63-0937-11f0-b61c-6045bd0fa337":
      return <Courses {...props} />;
    case "35499943-0937-11f0-b61c-6045bd0fa337":
      return <VacancyComponent {...props} />;
    case "35499d06-0937-11f0-b61c-6045bd0fa337":
      return <ContractComponent {...props} />;
    case "3549a0ff-0937-11f0-b61c-6045bd0fa337":
      return <ContactUsComponent {...props} />;
    case "3549a199-0937-11f0-b61c-6045bd0fa337":
      return <AboutUs {...props} />;
    case "35499a04-0937-11f0-b61c-6045bd0fa337":
      return <ApprenticesComponent {...props} />;
    case "35499238-0937-11f0-b61c-6045bd0fa337":
      return <ProductComponent {...props} />;
    case "35499c7c-0937-11f0-b61c-6045bd0fa337":
      return <WhyWorkForUs {...props} />;
    case "35499789-0937-11f0-b61c-6045bd0fa337":
      return <ServiceComponent {...props} />;
    default:
      return <></>;
  }
};

const useTabsList = (prosSettings) => {
  const [ProSettingsTabList, setProSettingsTabList] = useState([]);
  const [proSettingsObject, setProSettingsObject] = useState({});

  useEffect(() => {
    // prepare list of switched on tabs and mandatory tabs
    let tempProSettingsObj = {};

    if (prosSettings && prosSettings?.length > 0) {
      prosSettings.forEach((setting) => {
        if (
          setting.tabType === "MANDATORY_TABS" ||
          (setting.primaryToggle && setting.secondaryToggle)
        )
          tempProSettingsObj[setting.masterDataId] = setting;
      });
      setProSettingsObject(tempProSettingsObj);

      // return list of tabs in order and with component
      let tempTabList = [];
      tabsOrder.forEach((tab) => {
        if (tempProSettingsObj[tab.masterDataId]) {
          tempTabList.push({
            ...tempProSettingsObj[tab.masterDataId],
            ...tab,
            component: (params) =>
              masterDataToComponentMapping(tab.masterDataId, params),
          });
        }
      });
      setProSettingsTabList(tempTabList);
    }
  }, [prosSettings]);

  return { ProSettingsTabList, proSettingsObject };
};

export default useTabsList;
